// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"ecc868e5","135":"dbc33d9e","271":"3c73ca54","301":"3281358d","387":"468fe799","400":"16d32e01","798":"291693fc","968":"16d32e01"}[chunkId] + ".chunk.css";
};